import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "detail-root" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "account-badge" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "name-line" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "nick"
}
const _hoisted_8 = { class: "top-actions" }
const _hoisted_9 = { class: "status-strip" }
const _hoisted_10 = { class: "ss-item" }
const _hoisted_11 = { class: "ss-item" }
const _hoisted_12 = { class: "ss-val" }
const _hoisted_13 = { class: "ss-item" }
const _hoisted_14 = { class: "ss-val" }
const _hoisted_15 = { class: "ss-item" }
const _hoisted_16 = { class: "ss-val" }
const _hoisted_17 = {
  key: 0,
  class: "stats-bar"
}
const _hoisted_18 = { class: "stat-card" }
const _hoisted_19 = { class: "sc-val" }
const _hoisted_20 = { class: "content-wrap" }
const _hoisted_21 = { class: "scroll-area" }
const _hoisted_22 = {
  key: 0,
  class: "loading"
}
const _hoisted_23 = {
  key: 1,
  class: "empty"
}
const _hoisted_24 = { class: "rec-top" }
const _hoisted_25 = { class: "rec-top-row1" }
const _hoisted_26 = {
  key: 0,
  class: "live-dot"
}
const _hoisted_27 = { class: "rec-desk" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "pk-real-showdown"
}
const _hoisted_30 = { class: "showdown-info" }
const _hoisted_31 = { class: "rec-time" }
const _hoisted_32 = { class: "rec-round" }
const _hoisted_33 = {
  key: 0,
  class: "rec-settle-time"
}
const _hoisted_34 = { class: "showdown-row" }
const _hoisted_35 = { class: "pc-rank" }
const _hoisted_36 = { class: "pc-suit" }
const _hoisted_37 = {
  key: 0,
  class: "playing-card empty"
}
const _hoisted_38 = { class: "showdown-vs" }
const _hoisted_39 = {
  key: 0,
  class: "vs-score-xian"
}
const _hoisted_40 = {
  key: 1,
  class: "vs-score-zhuang"
}
const _hoisted_41 = { class: "pc-rank" }
const _hoisted_42 = { class: "pc-suit" }
const _hoisted_43 = {
  key: 1,
  class: "playing-card empty"
}
const _hoisted_44 = {
  key: 1,
  class: "pk-zone"
}
const _hoisted_45 = { class: "pk-row" }
const _hoisted_46 = { class: "pk-cards" }
const _hoisted_47 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_48 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_49 = { class: "pk-row" }
const _hoisted_50 = { class: "pk-cards" }
const _hoisted_51 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_52 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_53 = { class: "rec-amounts" }
const _hoisted_54 = { class: "am" }
const _hoisted_55 = { class: "am-val gold" }
const _hoisted_56 = { class: "am" }
const _hoisted_57 = { class: "am" }
const _hoisted_58 = { class: "am-val dim" }
const _hoisted_59 = { class: "pager-bar" }
const _hoisted_60 = {
  key: 0,
  class: "pg-num"
}
const _hoisted_61 = {
  key: 1,
  class: "pg-num"
}

import { ref, computed, onMounted, onUnmounted, inject, type Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Tools from '@/ts/Tools';
import { GAME_TYPE_MAP } from '@/ts/roomName';
import { resolveRoomName, setRoomNameMap } from '@/ts/roomNameStore';
import RoomVO from '@/ts/VO/RoomVO';
import SignalRClient from '@/ts/SignalRClient';

const pageSize = 20;

// 推送已处理过的订单号 / 该订单已计入的收入金额（用于去重，重新拉页时清空）

export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));
const userName = ref(route.params.userName as string || '');
const nickName = ref('');

// 返回时回到主播列表页（首页的“主播列表”标签）
function goBack() {
  router.push({ name: 'home', query: { tab: 'recharge' } });
}

// 实时状态（来自列表接口 / GetAccountBets / 服务端推送）
// 进入详情时先用列表已知的实时状态做种子，避免接口滞后导致误判“离线”
const online = ref(route.query.online === '1');
const onlineTime = ref((route.query.ot as string) || '');
const lastOfflineTime = ref((route.query.lo as string) || '');
const room = ref((route.query.room as string) || '');

const range = ref('today');
const loading = ref(false);
const records = ref<any[]>([]);
const currentPage = ref(1);
const totalPages = ref(0);
const totalCount = ref(0);
const totalNetWin = ref(0);
const pushedOrders = new Set<string>();
const pushedWin = new Map<string, number>();

// ===== 伪装/真实卡牌切换（由父组件统一 debugMode 控制） =====
const REAL_SUIT: Record<string, string> = { spade: '♠', heart: '♥', club: '♣', diamond: '♦' };
const REAL_RANK: Record<number, string> = { 1: 'A', 11: 'J', 12: 'Q', 13: 'K' };
function realSuitSymbol(suit: string) { return REAL_SUIT[suit] || ''; }
function realRankDisplay(n: number) { return REAL_RANK[n] || String(n); }

const totalNetWinStr = computed(() => {
  const v = totalNetWin.value;
  return Tools.formatMoney(v, { showSign: true });
});
const netWinClass = computed(() => totalNetWin.value > 0 ? 'positive' : totalNetWin.value < 0 ? 'negative' : '');
const netWinCardClass = computed(() => totalNetWin.value > 0 ? 'card-win' : totalNetWin.value < 0 ? 'card-lose' : '');
function setRange(r: string) {
  range.value = r;
  currentPage.value = 1;
  loadData();
}

function goPage(p: number) {
  if (p < 1 || p > totalPages.value) return;
  currentPage.value = p;
  loadData();
}

async function loadData() {
  loading.value = true;
  try {
    const now = new Date();
    let start: string, end: string = toDateStr(now);
    if (range.value === 'today') start = end;
    else if (range.value === 'yesterday') { start = end = toDateStr(new Date(now.getTime() - 86400000)); }
    else if (range.value === '2d') start = toDateStr(new Date(now.getTime() - 86400000));
    else if (range.value === '3d') start = toDateStr(new Date(now.getTime() - 2 * 86400000));
    else if (range.value === '7d') start = toDateStr(new Date(now.getTime() - 6 * 86400000));
    else start = toDateStr(new Date(now.getTime() - 29 * 86400000));

    const resp = await Tools.FetchGetAsync<any>('Game/GetAccountBets', {
      userName: userName.value,
      startDate: start,
      endDate: end,
      page: currentPage.value,
      pageSize: pageSize
    });
    if (resp.CheckIsOk() && resp.Data) {
      records.value = resp.Data.data || [];
      // 整页重拉：服务端数据才是准的，清空推送去重账本
      pushedOrders.clear();
      pushedWin.clear();
      totalPages.value = resp.Data.pagecount || 0;
      totalCount.value = resp.Data.allcount || 0;
      // 后端聚合的统计，不再前端拉全量数据计算
      if (resp.Data.stats) {
        totalNetWin.value = resp.Data.stats.total_win || 0;
      }
      if (records.value.length > 0 && records.value[0].nickName) {
        nickName.value = records.value[0].nickName;
      }
      // 实时状态字段（服务端实时计算）
      // online 以“已确认为在线”为准：列表种子或服务端推送若已判在线，接口的滞后 false 不将其降级
      online.value = online.value || !!resp.Data.online;
      onlineTime.value = resp.Data.onlineTime || onlineTime.value;
      lastOfflineTime.value = resp.Data.lastOfflineTime || lastOfflineTime.value;
      room.value = resp.Data.room || room.value;
    }
  } finally {
    loading.value = false;
  }
}

function toDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// ===== 直播间互动玩法映射（见 @/ts/roomName）=====
function roomDisplayName(r: any): string {
  const zhuo = r.game_zhuo_name || '';
  const gn = r.game_name || '';
  const gc = zhuo; //r.game_code || '';

  // if (gn && zhuo) return `${gn} ${zhuo}`;
  // if (gn) return `${gn} ${gc}`;
  // if (zhuo) return zhuo;
  // 兜底：用前端映射
  const type = typeof r.game_type === 'string' ? parseInt(r.game_type) : r.game_type;
  const name = GAME_TYPE_MAP[type];
  if (name && gc) return `${name} ${gc}`;
  return name || gc || '';
}

// ===== 直播互动结果判断（仅 debug/真实模式显示） =====

function betLabel(r: any): string {
  if (!r.is_finish) return '';
  return r.bet_direction || '';
}

function betColorClass(r: any): string {
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'result-win';
  if (win < 0) return 'result-lose';
  return '';
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function winColor(val: number): string {
  if (val > 0) return 'positive';
  if (val < 0) return 'negative';
  return 'zero';
}

function recordBoxClass(r: any): string {
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'record-win';
  if (win < 0) return 'record-lose';
  return '';
}

// ===== 卡牌解析 =====
const SUIT_MAP: Record<string, { symbol: string; cls: string }> = {
  S: { symbol: '🖤', cls: 'spade' },    // 黑桃 — 黑色心/桃
  H: { symbol: '❤️', cls: 'heart' },    // 红桃 — 红色心
  C: { symbol: '🌸', cls: 'club' },     // 梅花 — 花
  D: { symbol: '🟦', cls: 'diamond' },  // 方片 — 方块
};
const RANK_VALUE: Record<string, number> = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10, '11': 11, '12': 12, '13': 13 };

function parseCards(raw: string | null): { count: number; symbol: string; suit: string }[] {
  if (!raw || raw === '-' || raw === '[]') return [];
  try {
    const arr: string[] = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((c: string) => typeof c === 'string' && c.includes('.'))
      .map((c: string) => {
        const [suit, rank] = c.split('.');
        const info = SUIT_MAP[suit] || { symbol: suit, cls: '' };
        return { count: RANK_VALUE[rank] || 0, symbol: info.symbol, suit: info.cls };
      });
  } catch {
    return [];
  }
}

// 下注/结算推送：服务端已带完整记录，前端直接插入/更新列表，不重新拉取整页
function applyPushedRecord(rec: any) {
  // 只处理当前查看的账号；列表按 bet_time 倒序，新记录只可能落在第 1 页
  if (!rec || !rec.order_number) return;
  if (rec.userName !== userName.value) return;
  if (currentPage.value !== 1) return;
  // “昨天”区间不含今天，推送的新记录不属于该区间，直接丢弃
  if (range.value === 'yesterday') return;

  const no = rec.order_number;
  const idx = records.value.findIndex((r: any) => r && r.order_number === no);
  if (idx >= 0) {
    // 已存在（例如刚打开页面已经刷到这条）→ 原地更新，不新增条目，避免重复
    records.value[idx] = rec;
  } else if (!pushedOrders.has(no)) {
    // 新记录插到最前；超过每页固定条数则移除末尾多余的（推送 100 条也只显示一页）
    records.value = [rec, ...records.value].slice(0, pageSize);
    totalCount.value += 1;                                   // 直播场次
    totalPages.value = Math.max(totalPages.value, Math.ceil(totalCount.value / pageSize));
  }
  pushedOrders.add(no);

  // 直播收入：仅已结算才计入；同一单只累加差额，避免下注→结算两次推送重复计
  if (rec.is_finish === 1) {
    const win = Number(rec.real_win_total_amount) || 0;
    totalNetWin.value += win - (pushedWin.get(no) || 0);
    pushedWin.set(no, win);
  }
  if (rec.nickName) nickName.value = rec.nickName;
}
const onAccountDataPush = (data: any) => applyPushedRecord(data?.record);

onMounted(() => {
  loadData();
  // 兜底：深链/刷新进入时首页未加载房间列表，主动拉一次填充 RoomNumber->RoomName 映射
  SignalRClient.Instance.InvokeAsync<{ [key: string]: RoomVO }>("GetRoomList")
    .then((resp) => {
      const list: RoomVO[] = [];
      for (const key in resp) {
        const room = resp[key];
        Object.setPrototypeOf(room, RoomVO.prototype);
        list.push(room);
      }
      setRoomNameMap(list);
    })
    .catch(() => {});
  // 服务端推送的账号状态实时更新（在线/房间/时间）
  SignalRClient.Instance.AddEventListener("onUserStatusUpdate", (data: any) => {
    if (data?.userName !== userName.value) return;
    online.value = !!data.online;
    onlineTime.value = data.onlineTime || '';
    lastOfflineTime.value = data.lastOfflineTime || '';
    room.value = data.room || '';
  });
  // 下注/结算推送：服务端带完整记录，前端直接插入/更新（去重 + 限制每页条数）
  SignalRClient.Instance.AddEventListener("onBet", onAccountDataPush);
  SignalRClient.Instance.AddEventListener("onSettle", onAccountDataPush);
});

onUnmounted(() => {
  SignalRClient.Instance.RemoveEventListener("onUserStatusUpdate");
  SignalRClient.Instance.RemoveEventListener("onBet");
  SignalRClient.Instance.RemoveEventListener("onSettle");
});

function fmtTime(v: any): string {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "back",
        onClick: goBack
      }, "↩"),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(userName.value.charAt(0)), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(userName.value), 1),
          (nickName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nickName.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'today' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setRange('today')))
        }, "今", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'yesterday' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setRange('yesterday')))
        }, "昨", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '2d' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setRange('2d')))
        }, "2d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '3d' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setRange('3d')))
        }, "3d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '7d' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setRange('7d')))
        }, "7d", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ss-label" }, "状态", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["ss-val", online.value ? 'on' : 'off'])
        }, _toDisplayString(online.value ? '直播中' : '离线'), 3)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ss-label" }, "所在房间", -1)),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(resolveRoomName)(room.value) || '未进房'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ss-label" }, "上线时间", -1)),
        _createElementVNode("span", _hoisted_14, _toDisplayString(onlineTime.value ? fmtTime(onlineTime.value) : '—'), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ss-label" }, "最后离线", -1)),
        _createElementVNode("span", _hoisted_16, _toDisplayString(lastOfflineTime.value ? fmtTime(lastOfflineTime.value) : '—'), 1)
      ])
    ]),
    (_unref(debugMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(totalCount.value), 1),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sc-label" }, "直播场次", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stat-card", netWinCardClass.value])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["sc-val", netWinClass.value])
            }, _toDisplayString(totalNetWinStr.value), 3),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sc-label" }, "直播收入", -1))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, "正在拉取直播数据..."))
          : (records.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, "暂无直播记录"))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (r) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["record", [recordBoxClass(r), { unfinished: !r.is_finish }]]),
            key: r.order_number || r.id
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (!r.is_finish)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_27, _toDisplayString(roomDisplayName(r)), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["rec-status", { done: r.is_finish }])
                }, _toDisplayString(r.is_finish ? '已结束' : '直播中'), 3),
                (_unref(debugMode) && betLabel(r))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["rec-result-chip", betColorClass(r)])
                    }, [
                      _createTextVNode(_toDisplayString(betLabel(r)), 1),
                      (r.odds)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_28, " · " + _toDisplayString(r.odds), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(formatTime(r.bet_time)), 1),
                    _createElementVNode("span", _hoisted_32, "第" + _toDisplayString(r.main_ju_number) + "回合", 1),
                    (r.settlement_time)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "结束于 " + _toDisplayString(formatTime(r.settlement_time)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["playing-card", c.suit]),
                        key: 'x'+ci
                      }, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(realRankDisplay(c.count)), 1),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(realSuitSymbol(c.suit)), 1)
                      ], 2))
                    }), 128)),
                    (!parseCards(r.xian_cards).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[14] || (_cache[14] = [
                          _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                        ])))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      (r.xian_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(r.xian_dian), 1))
                        : _createCommentVNode("", true),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "vs-word" }, "vs", -1)),
                      (r.zhuang_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(r.zhuang_dian), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["playing-card", c.suit]),
                        key: 'z'+ci
                      }, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(realRankDisplay(c.count)), 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(realSuitSymbol(c.suit)), 1)
                      ], 2))
                    }), 128)),
                    (!parseCards(r.zhuang_cards).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[16] || (_cache[16] = [
                          _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (!_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "pk-tag blue" }, "我方", -1)),
                      _createElementVNode("span", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["chip", c.suit]),
                            key: 'x'+ci
                          }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                        }), 128)),
                        (!parseCards(r.xian_cards).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, "-"))
                          : _createCommentVNode("", true)
                      ]),
                      (r.xian_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                            _createTextVNode(_toDisplayString(r.xian_dian), 1),
                            _cache[17] || (_cache[17] = _createElementVNode("i", null, "分", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "pk-divider" }, [
                      _createElementVNode("span", null, "VS")
                    ], -1)),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "pk-tag red" }, "对方", -1)),
                      _createElementVNode("span", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: _normalizeClass(["chip", c.suit]),
                            key: 'z'+ci
                          }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                        }), 128)),
                        (!parseCards(r.zhuang_cards).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, "-"))
                          : _createCommentVNode("", true)
                      ]),
                      (r.zhuang_dian != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                            _createTextVNode(_toDisplayString(r.zhuang_dian), 1),
                            _cache[19] || (_cache[19] = _createElementVNode("i", null, "分", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "am-icon" }, "🎁", -1)),
                _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(Tools).formatMoney(r.total_betting_amount)), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "am-icon" }, "💰", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["am-val", winColor(r.real_win_total_amount)])
                }, _toDisplayString(_unref(Tools).formatMoney(r.real_win_total_amount)), 3)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "am-icon" }, "💳", -1)),
                _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(Tools).formatMoney(r.front_balance)) + " → " + _toDisplayString(_unref(Tools).formatMoney(r.after_balance)), 1)
              ])
            ])
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value <= 1 }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (goPage(currentPage.value - 1)))
        }, "‹", 2),
        (totalPages.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value) + " 页", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_61, "暂无数据")),
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value >= totalPages.value }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (goPage(currentPage.value + 1)))
        }, "›", 2)
      ])
    ]),
    _createElementVNode("span", {
      class: "float-refresh",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (loadData()))
    }, "↻")
  ]))
}
}

})